import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../../shared/base-api-template-service.model';
import {Core2Config} from '../../../shared/core2Config';
import { ApiVisa } from '../../../shared';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../../../shared/api-response.model';

@Injectable({
    providedIn: 'root'
  })
  export class LogisticProviderHdrService extends BaseApiTemplateService<any> {
      
    readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'delivery-logistic-provider/backoffice-ep';
  
    constructor(http: HttpClient) {
      super();
      this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'delivery-logistic-providery/backoffice-ep';
      this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'delivery-logistic-provider/backoffice-ep';
      this.httpClient = http;
    }

    public createAppGenericResource(dtoObject: any, visa: ApiVisa, guid:String): Observable<ApiResponseModel<any>> {
        let url;
        if (this.endpoint_path && visa.api_domain_url) {
          url = visa.api_domain_url + this.endpoint_path + '/credential/backoffice-ep/'+guid;
        }
        return this.httpClient.post<ApiResponseModel<any>>(
          url,
          dtoObject,
          this.getHttpHeader(visa)
        );
      }

      public updateAppGenericResource(dtoObject: any, visa: ApiVisa, guid:String): Observable<ApiResponseModel<any>> {
        let url;
        if (this.endpoint_path && visa.api_domain_url) {
          url = visa.api_domain_url + this.endpoint_path + '/credential/backoffice-ep/'+guid;
        }
        return this.httpClient.put<ApiResponseModel<any>>(
          url,
          dtoObject,
          this.getHttpHeader(visa)
        );
      }

      public deleteCredentialByGuid(visa: ApiVisa, guid:String): Observable<ApiResponseModel<any>> {
        let url;
        if (this.endpoint_path && visa.api_domain_url) {
          url = visa.api_domain_url + this.endpoint_path + '/credential/backoffice-ep/'+guid;
        }
        return this.httpClient.delete<ApiResponseModel<any>>(
          url,
          this.getHttpHeader(visa)
        );
     }
}